import { Calendar, CheckCircle, XCircle } from "lucide-react";
import { useState } from "react";
import { LEAVE_TYPES } from "utils/types";

export const ManagerApprovalDashboard = ({ requests, onUpdateRequest }) => {
    const [submitting, setSubmitting] = useState(false);
    const pendingRequests = requests.filter(r => r.status === 'pending');
    if (pendingRequests.length === 0) return null;

    const handleUpdateRequest = async (id, status) => {
        if (submitting) return;

        setSubmitting(true);
        await onUpdateRequest(id, status);
        setSubmitting(false);
    }

    return (
        <div className="bg-white rounded-lg shadow-md p-4 sm:p-6 my-6">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Pending Leave Approvals</h3>
            <div className="space-y-4">
                {pendingRequests.map(req => (
                    <div key={req.id} className="p-4 bg-gray-50 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border">
                        <div>
                            <p className="font-semibold text-gray-800">{req.employeeName}</p>
                            <p className="text-sm text-gray-600"><span className={`font-semibold ${LEAVE_TYPES[req.leaveType]?.color.replace('bg-', 'text-')}`}>{LEAVE_TYPES[req.leaveType]?.name}</span></p>
                            <p className="text-sm text-gray-500 flex items-center gap-2 mt-1"><Calendar size={14} /> {new Date(req.startDate + 'T00:00:00').toLocaleDateString('en-GB')} - {new Date(req.endDate + 'T00:00:00').toLocaleDateString('en-GB')}</p>
                            {req.comments && (
                                <div className="mt-2 p-2 bg-gray-100 rounded-md">
                                    <p className="text-xs font-medium text-gray-600 mb-1">Comments:</p>
                                    <p className="text-sm text-gray-700">{req.comments}</p>
                                </div>
                            )}
                        </div>
                        <div className="flex gap-2 flex-shrink-0">
                            <button onClick={() => handleUpdateRequest(req.id, 'approved')} className="px-3 py-1.5 bg-green-500 text-white rounded-md hover:bg-green-600 flex items-center gap-1 text-sm" disabled={submitting} ><CheckCircle size={16} /> Approve</button>
                            <button onClick={() => handleUpdateRequest(req.id, 'rejected')} className="px-3 py-1.5 bg-red-500 text-white rounded-md hover:bg-red-600 flex items-center gap-1 text-sm" disabled={submitting} ><XCircle size={16} /> Reject</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};